import React, { useContext, useEffect } from 'react';
import LoadinSpin from '../ui/LoadinSpin';
import { headTbl } from '../../data/tables';
import { useGetDta } from '../../hooks/useGetDta';
import Table from '../Table';
import { UserContext } from '../../context/user/ContextUser';
import moment from 'moment';
import { useForm } from '../../hooks/useForm';
import { Col, Form, Row } from 'react-bootstrap';
const TblConekta = ({ id = null }) => {
    const [values, handleInputChange, reset, setFormValue] = useForm({
        items: 50,
        status: 'paid',
        id,
    });
    const { loading, data, getInfo } = useGetDta(`openpay/pagos/conekta`, values, 'PUT');
    const { items, status, created_at } = values;

    const { usersState } = useContext(UserContext);
    useEffect(() => {
        setFormValue({ ...values, id });
    }, [id]);
    useEffect(() => {
        getInfo(`openpay/pagos/conekta`, values, 'PUT');
    }, [values]);
    const UserColumn = ({ row }) => {
        const clienteEncontrado = usersState?.usuarios.find((cliente) => cliente.id_ko === row.original.customer_id);
        return <span>{clienteEncontrado ? clienteEncontrado.nombre : ''}</span>;
    };

    const StatusColumn = ({ row }) => {
        return (
            <span>
                {row.original.status === 'paid' && (
                    <i className="mdi mdi-check-all text-success fs-3 fw-bold" title="Pagado" />
                )}
                {row.original.status === 'pending_payment' && (
                    <i className="mdi mdi-clock-alert text-warning fs-3 fw-bold" title="Pendiente de pagar" />
                )}
            </span>
        );
    };
    const TotalColumn = ({ row }) => {
        return <span>${row.original.amount / 100}</span>;
    };
    const FechaColumn = ({ row }) => {
        const formattedDate = moment.unix(row.original.paid_at).format('YYYY-MM-DD HH:mm:ss');

        return <span>{formattedDate}</span>;
    };

    const columns = [
        {
            Header: 'Fecha de pago',
            accessor: 'paid_at',
            sort: true,
            Cell: FechaColumn,
        },
        {
            Header: 'Cliente',
            accessor: 'customer_id',
            sort: true,
            Cell: UserColumn,
        },
        {
            Header: 'Estatus',
            accessor: 'status',
            sort: true,
            Cell: StatusColumn,
        },
        {
            Header: 'Cantidad',
            accessor: 'amount',
            sort: true,
            Cell: TotalColumn,
        },
    ];
    const sizePerPageList = headTbl(data.length);
    if (loading) return <LoadinSpin />;

    return (
        <div className="mt-2">
            <Row>
                <Col md={2}>
                    <Form.Label>Mostrar items </Form.Label>

                    <Form.Select value={items} onChange={handleInputChange} name="items">
                        <option value="50">50 por página</option>
                        <option value="100">100 por página</option>
                        <option value="200">200 por página</option>
                        <option value="500">500 por página</option>
                    </Form.Select>
                </Col>
                <Col md={2}>
                    <Form.Label>Estado</Form.Label>

                    <Form.Select value={status} onChange={handleInputChange} name="status">
                        <option value="">Todos los estados</option>
                        <option value="paid">Completado</option>
                        <option value="pending_payment">En progreso</option>

                        {/* Add other status options as needed */}
                    </Form.Select>
                </Col>
            </Row>
            <Table
                columns={columns}
                data={data}
                pageSize={25}
                sizePerPageList={sizePerPageList}
                isSortable={true}
                pagination={true}
                isSearchable={true}
                searchBoxClass="mb-2"
            />
        </div>
    );
};

export default TblConekta;
